module.exports = "/Public/build/67e051c7f491a0c8008be44863593d15.svg";


//////////////////
// WEBPACK FOOTER
// ./data/assets/marker-project-active.svg
// module id = 269
// module chunks = 0